import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useContext, useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import { BreadcrumbContext } from '../../../../components/Breadcrumb';
import Loader from "../../../../components/Loader";
import Alert from "../../../../components/Alert";
import { Link } from "react-router-dom";
var AcceptOwnershipTransfer = function () {
    var id = useParams().id;
    var title = 'Accept Ownership Transfer';
    var _a = useState(null), transfer = _a[0], setTransfer = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(false), inSubmit = _c[0], setInSubmit = _c[1];
    var _d = useState(false), success = _d[0], setSuccess = _d[1];
    var setBreadcrumb = useContext(BreadcrumbContext).setBreadcrumb;
    useEffect(function () {
        setBreadcrumb([
            {
                to: "/",
                text: "Home",
                active: false
            },
            {
                to: null,
                text: title,
                active: true
            }
        ]);
        if (id) {
            var isSubscribed_1 = true;
            setError(null);
            var getTransfer = CloudFunctions.httpsCallable('oncall');
            getTransfer({
                name: "getOwnershipTransfer",
                data: {
                    transferId: id
                }
            }).then(function (res) {
                if (isSubscribed_1) {
                    setTransfer(res.data);
                }
            }).catch(function (err) {
                if (isSubscribed_1) {
                    setError(err.message);
                }
            });
            return function () { isSubscribed_1 = false; };
        }
        else {
            setError("Transfer link not found");
        }
    }, [id, setBreadcrumb, title]);
    return (_jsx(_Fragment, { children: success ? (_jsx(Navigate, { to: "/" })) : (_jsx(_Fragment, { children: _jsx("div", { className: "container-fluid", children: _jsx("div", { className: "animated fadeIn", children: _jsxs("div", { className: "card", children: [_jsx("div", { className: "card-header", children: title }), _jsxs("div", { className: "card-body", children: [error !== null &&
                                        _jsx(Alert, { type: "danger", message: error, dismissible: true, onDismiss: function () { return setError(null); } }), transfer === null ? (error === null && _jsx(Loader, { text: "Loading the transfer request..." })) : (_jsxs(_Fragment, { children: [_jsxs("div", { className: "text-center", children: [_jsx("strong", { children: transfer.fromOwnerName }), " wants to transfer ownership of the following account(s) to you:", _jsx("ul", { className: "list-unstyled mt-2 mb-0", children: transfer.accounts.map(function (a) { return _jsx("li", { children: _jsx("strong", { children: a.name }) }, a.id); }) }), "Do you want to accept?"] }), _jsxs("div", { className: "text-center mt-3", children: [_jsxs("button", { className: "btn btn-primary mr-2", disabled: inSubmit, onClick: function (e) {
                                                            e.preventDefault();
                                                            setInSubmit(true);
                                                            var acceptTransfer = CloudFunctions.httpsCallable('oncall');
                                                            acceptTransfer({
                                                                name: "acceptOwnershipTransfer",
                                                                data: {
                                                                    transferId: id
                                                                }
                                                            }).then(function (res) {
                                                                setSuccess(true);
                                                            }).catch(function (err) {
                                                                setInSubmit(false);
                                                                setError(err.message);
                                                            });
                                                        }, children: [inSubmit && _jsx(Loader, {}), "Yes, accept ownership"] }), _jsx(Link, { className: inSubmit ? ("btn btn-secondary ml-2 btn-disabled") : ("btn btn-secondary ml-2"), to: "/", onClick: function (e) {
                                                            if (inSubmit) {
                                                                e.preventDefault();
                                                            }
                                                        }, children: "Ignore" })] })] }))] })] }) }) }) })) }));
};
export default AcceptOwnershipTransfer;
